import {Component} from '@angular/core';
import {BreadcrumbsService, IBreadcrumbPart} from './breadcrumbs.service';

@Component({
    selector: 'kkk-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent {
    constructor(private service: BreadcrumbsService) {
    }

    get parts(): IBreadcrumbPart[] {
        return this.service.parts;
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/breadcrumbs/breadcrumbs.component.ts